





































import {Component, Watch, Prop, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import Motorista from '@/model/resource/Motorista'
import Responsavel from '@/model/resource/Responsavel'

@Component
export default class DriverPerformanceBar extends Vue {
  @Prop({type: Object, required: true}) motorista!: Motorista
  @Getter('auth/responsavel') user!: Responsavel

  qtdPendente = this.motorista.qtdEntregasPendentes ||  0
  qtdFinalizadasSucesso = this.motorista.qtdEntregasFinalizadasSucesso || 0
  qtdFinalizadasOcorrencia = this.motorista.qtdEntregasFinalizadasOcorrencia || 0
  qtdDevolvidas = this.motorista.qtdEntregasDevolvidas || 0

  get barTotal() {
      return this.qtdPendente + this.qtdFinalizadasSucesso + this.qtdFinalizadasOcorrencia + this.qtdDevolvidas
  }

  get pendentePercent() {
      return 100 * (this.qtdPendente / this.barTotal)
  }

  get finalizadaSucessoPercent() {
      return 100 * (this.qtdFinalizadasSucesso / this.barTotal)
  }

  get finalizadaOcorrenciaPercent() {
      return 100 * (this.qtdFinalizadasOcorrencia / this.barTotal)
  }

  get devolvidaPercent() {
      return 100 * (this.qtdDevolvidas / this.barTotal)
  }
}
